import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Step from 'book-calculator/components/Step';
import InteriorFieldset from 'book-calculator/containers/InteriorFieldset';

const InteriorStep = ({ step }) => (
    <Step
        step={step}
        title={<FormattedMessage id="steps.interior.heading" />}
        description={<FormattedMessage id="steps.interior.description" />}
    >
        <InteriorFieldset />
    </Step>
);

InteriorStep.propTypes = {
    step: PropTypes.number.isRequired,
};

export default InteriorStep;
